"use strict";

module.exports = function(config, get, post) {
	const create = (indicator) => {
		return post("/v2/org/indicators", indicator);
	};

	const update = (indicatorId, indicator) => {
		return post(`/v2/org/indicators/${indicatorId}`, indicator);
	};

	const remove = (indicatorId) => {
		return post(`/v2/org/indicators/${indicatorId}/delete`);
	};

	return { create, update, remove };
};